<template>

    <v-menu
      bottom
      origin="center center"
      transition="scale-transition"
      dense
    >
      <template v-slot:activator="{ on }">
        <v-btn
          v-on="on"
          text
          close-on-click
          offset-y>
            <v-icon color="primary">mdi-account-circle-outline</v-icon>
            <v-icon color="primary">mdi-menu-down</v-icon>
        </v-btn>
      </template>

      <!-- user menu -->
        <v-card>
            <v-list>
                <v-list-item>
                    <v-list-item-avatar>
                        <v-icon color="primary" large>mdi-account-circle-outline</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                        <v-list-item-title class="subtitle-1 font-weight-bold">{{ username }}</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                    </v-list-item-action>
                </v-list-item>
            </v-list>

            <v-divider></v-divider>

            <!-- user/role specific actions -->
            <v-list>
                <v-list-item @click="logoff">                
                    <v-list-item-avatar>
                        <v-icon>exit_to_app</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                        <v-list-item-title class="body-2">Logoff</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                    </v-list-item-action>
                </v-list-item>            
            </v-list>
        </v-card>    

    </v-menu>

</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: 'AppUserMenu',
    data() {
        return {
            username: ''
        }
    },
    computed: {
      ...mapGetters(['getAccount']),
    },
    created() {
      this.username = this.getAccount.username
    },
    methods: {
        logoff() {
            sessionStorage.clear()
            this.$store.dispatch('resetState')
            this.$router.push({ path: '/' })            
        }
    }
}
</script>
